import {MenuLink} from '@/components/custom/header/mainmenu/menuLink'
import {cva} from 'class-variance-authority'
import {cn} from '@/lib/utils'
import {usePathname} from "next/navigation";

const listItemVariants = cva('flex h-full cursor-pointer flex-row items-center', {
    variants: {
        state: {
            active: 'active text-secondary',
            inactive: ''
        },
        children: {
            false: '',
            true: 'after-triangle'
        }
    },
    defaultVariants: {
        state: 'inactive',
        children: false
    }
})

export type MainMenuItemModel = {
    id: number
    level?: number
    url: string
    fullPath?: boolean
    text: string
    children?: MainMenuItemModel[]
    teaser?: {
        headline: string;
        text: string;
        image: {
            src: string;
            width?: number;
            height?: number;
            alt?: string;
        };
        url: string;
        content?: any;
        link?: any;
    },
    active?: boolean;
}

interface MainMenuItemProps {
    item: MainMenuItemModel,
    locale: string,
    activeMainMenuItem: any,
    setActiveMainMenuItem: (item: any) => void,
    setSubactive: (item: any) => void,
    setCurrentSubItems: (value: MainMenuItemModel[]) => void,
}

const MainMenuItem = ({
                          item,
                          locale,
                          activeMainMenuItem,
                          setActiveMainMenuItem,
                          setSubactive,
                          setCurrentSubItems,
                      }: MainMenuItemProps) => {
    const state = activeMainMenuItem === item.id ? 'active' : 'inactive'
    const children = item.children !== undefined

    const handleHover = () => {
        setActiveMainMenuItem(item.id)

        if (item.children && item.children.length > 0) {
            setSubactive(true)
            setCurrentSubItems(item.children)
        } else {
            setSubactive(false)
            // setCurrentSubItems([])
        }
    }

    const handleMouseLeave = () => {
        setSubactive(false)
    }

    return (
        <li
            data-menu-item={item.id}
            onMouseOver={handleHover}
            onMouseLeave={handleMouseLeave}
            className={cn(listItemVariants({state, children}))}
        >
            <MenuLink link={item.url} label={item.text} absolutePath={item.fullPath} setSubactive={setSubactive} />
        </li>
    )
}

export {MainMenuItem}
